import { render, staticRenderFns } from "./OONewCellButton.vue?vue&type=template&id=12e84e06&"
import script from "./OONewCellButton.vue?vue&type=script&lang=ts&"
export * from "./OONewCellButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports